import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { getGameList } from '~/api';
import { GameData, PaginationRequest } from '~/types';
import { MINUTE } from '~/constants';
import missionGameKey from '../missionGame/missionGameKey';

export const GAME_LIST_FETCH_SIZE = 10;

const useGetMissionGameListQuery = () => {
  return useSuspenseInfiniteQuery({
    queryKey: missionGameKey.getGameList(),
    queryFn: ({ pageParam }) =>
      getGameList({
        page: pageParam,
      } as PaginationRequest<void>),
    initialPageParam: 1,
    getNextPageParam: ({ data, status }, _, lastPageParam) => {
      if (data.length < GAME_LIST_FETCH_SIZE) return undefined;

      const nextPage = lastPageParam + 1;
      return status === 200 && data.length === 0 ? undefined : nextPage;
    },
    select: (response) => ({
      pages: response.pages.flatMap((page) => {
        if (page.data) return page.data as GameData[];
        return [];
      }),
      pageParams: response.pageParams,
    }),
    staleTime: 10 * MINUTE,
  });
};

export default useGetMissionGameListQuery;
